export interface TutorialStep {
  id: string;
  target: string;
  targetMobile?: string;
  icon?: string;
  title: string;
  sub?: string;
  description: string;
  page: string;
  type: 'passive' | 'interactive';
  /** Page attendue après l'interaction (étapes interactives). */
  navigateTo?: string;
  tooltipPosition?: 'top' | 'bottom';
  padding?: number;
  skipIfMissing?: boolean;
  isLast?: boolean;
}

/**
 * Generates tutorial steps based on user access.
 * @param hasApporteur43397 - Whether the user has at least one contract with apporteur 43397
 */
export function getTutorialSteps(hasApporteur43397 = true): TutorialStep[] {
  const steps: TutorialStep[] = [
    // === HOME PAGE ===
    {
      id: 'acces-rapides',
      target: '[data-tutorial="acces-rapides"]',
      targetMobile: '[data-tutorial="pwa-actions"]',
      icon: '\u26A1',
      title: 'Vos raccourcis',
      sub: 'Tout à portée de main',
      description: hasApporteur43397
        ? 'Nouveau devis, modification de contrat, déclaration de sinistre ou assistance. Vos actions les plus fréquentes accessibles en un clic.'
        : 'Consultation de votre contrat, déclaration de sinistre ou assistance. Vos actions les plus fréquentes accessibles en un clic.',
      page: '/',
      type: 'passive',
      tooltipPosition: 'bottom',
      padding: 8,
    },
    {
      id: 'home-contracts',
      target: '[data-tutorial="home-contracts"]',
      icon: '\uD83D\uDCCB',
      title: 'Vos contrats',
      sub: 'Vos véhicules, d\'un coup d\'oeil',
      description: hasApporteur43397
        ? 'Retrouvez tous vos véhicules assurés et leur statut. Vous changez de monture ? Assurez un nouveau véhicule directement depuis cette section.'
        : 'Retrouvez tous vos véhicules assurés et leur statut.',
      page: '/',
      type: 'passive',
      tooltipPosition: 'top',
      padding: 8,
      skipIfMissing: true,
    },
    {
      id: 'home-accidents',
      target: '[data-tutorial="home-accidents"]',
      icon: '\u26A0\uFE0F',
      title: 'Vos sinistres',
      sub: 'On reste à vos côtés',
      description:
        'Déclarez rapidement votre sinistre et suivez son avancement.',
      page: '/',
      type: 'passive',
      tooltipPosition: 'top',
      padding: 8,
      skipIfMissing: true,
    },
    {
      id: 'home-promoblocs',
      target: '[data-tutorial="home-promoblocs"]',
      icon: '\uD83C\uDF81',
      title: 'Vos services & avantages',
      sub: 'Plus qu\'une assurance',
      description: hasApporteur43397
        ? 'Téléchargez votre Mémo Véhicule, parrainez un proche pour une récompense, ou explorez les offres exclusives de nos partenaires.'
        : 'Téléchargez votre Mémo Véhicule Assuré, ou explorez les offres exclusives de nos partenaires.',
      page: '/',
      type: 'passive',
      tooltipPosition: 'top',
      padding: 8,
      skipIfMissing: true,
    },
    {
      id: 'home-contact',
      target: '[data-tutorial="home-contact"]',
      icon: '\uD83D\uDCDE',
      title: 'On est là pour vous',
      sub: 'Une question ? Nous avons la réponse.',
      description:
        'Par téléphone du lundi au vendredi de 9h à 18h, ou par e-mail à tout moment — notre équipe est disponible pour vous accompagner.',
      page: '/',
      type: 'passive',
      tooltipPosition: 'top',
      padding: 8,
      skipIfMissing: true,
      isLast: true,
    },
  ];

  return steps;
}
